import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { _showStates } from '../../../App';
import { validationHandlers, validationInitialState, validationReducer } from '../reducers/ValidationReducer';
import { PapsContext } from './PapsContext';
import { AppContext } from './AppProvider';
import { DatabaseContext } from './DatabaseContext';
import { CurrentSettingsContext } from './SettingsDataContext';

export const ValidationContext = createContext();
/** Top level provider the App
@componentContexts [StartContext]
@provides validation_state, validation_handlers 
@description Returns the Auth object for the App. Will return a `PageDimmer` until the appUser && appUser.profileValidated is set  
*/
const ValidationProvider = (props) => {

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainAuth } = app_state ?? {}

  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext ?? {}

  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}

  const { pathViews, sharePath } = paps_state ?? {}

  // pageContext  
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appSignIn, signInEmail } = aps_global ?? {}

  // ValidationReducer
  const initState = validationInitialState({ database_fns, mainAuth, validationValidated: false, pathViews, sharePath, appSignIn, signInEmail })
  const [validation_state, validation_dispatch] = useReducer(validationReducer, initState);

  const validation_handlers = useMemo(
    () => validationHandlers(validation_dispatch),
    [validation_dispatch]
  );

  if (_showStates.any && _showStates.validation) {
    console.log('--- validation_state ---')
    console.log(Object.keys(validation_state))
    console.log(Object.keys(validation_handlers))
  }

  const provider = () => <ValidationContext.Provider value={{ validation_handlers, validation_state, }} >
    {props.children}
  </ValidationContext.Provider >

  return provider()

}

export default ValidationProvider

